/// <amd-module name="Wit/Common/HubError/Components/HubError" />
import * as React from "react";
import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Button } from "VSSUI/Button";
import { ButtonGroup } from "VSSUI/ButtonGroup";
import { ZeroData } from "VSSUI/ZeroData";
import * as Resources from "Wit/Common/HubError/Resources";
import { ExceptionInfo } from "../Models/Models";
import { IHubErrorProps } from "./HubError.Props";

const enum ErrorImagePaths {
    GeneralHubError = "ms.vss-work-web/hub-error-content/Content/hub-error-general.svg",
    ConfigurationRequired = "ms.vss-work-web/hub-error-content/Content/configuration-required.svg"
}

export class HubError extends VssComponent<IHubErrorProps> {
    constructor(props: IHubErrorProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element {
        const exceptionsInfoElement: JSX.Element = (
            <div className={this.props.className}>
                {this.props.exceptionsInfo.map((exceptionInfo, index) => (
                    <div key={index}>
                        {this.getErrorsList(exceptionInfo)}
                        {this.getErrorLinks(exceptionInfo)}
                    </div>
                ))}
            </div>
        );

        const isSettingsException = this.props.exceptionsInfo.some(e => e.isSettingsException || false);

        const imagePath = isSettingsException ? ErrorImagePaths.ConfigurationRequired : ErrorImagePaths.GeneralHubError;
        const errorText = isSettingsException ? Resources.ConfigurationRequired : Resources.GeneralErrorTitle;

        return (
            <ZeroData
                className="flex-grow"
                imagePath={getAssetLocation(this.context.pageContext, imagePath)}
                imageAltText={errorText}
                primaryText={errorText}
                secondaryText={exceptionsInfoElement}
            />
        );
    }

    private getErrorsList(exceptionInfo: ExceptionInfo): JSX.Element {
        const hasErrorsList: boolean = exceptionInfo.additionalMessages ? exceptionInfo.additionalMessages.length > 0 : false;
        return (
            <div>
                <div>
                    {exceptionInfo.exceptionMessageCustomRender
                        ? exceptionInfo.exceptionMessageCustomRender(exceptionInfo.exceptionMessage)
                        : exceptionInfo.exceptionMessage}
                </div>
                {hasErrorsList && (
                    <ul>
                        {exceptionInfo.additionalMessages!.map((e, i) => (
                            <li key={`Error${i}`}>
                                {exceptionInfo.additionalMessagesCustomRender ? exceptionInfo.additionalMessagesCustomRender(e) : e}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        );
    }

    private getErrorLinks(exceptionInfo: ExceptionInfo): JSX.Element {
        let primaryLink: JSX.Element | undefined;
        if (exceptionInfo.primaryLinkHref && exceptionInfo.primaryLinkText) {
            primaryLink = <Button text={exceptionInfo.primaryLinkText} href={exceptionInfo.primaryLinkHref} primary={true} />;
        }

        let secondaryLink: JSX.Element | undefined;
        if (exceptionInfo.secondaryLinkHref && exceptionInfo.secondaryLinkText) {
            secondaryLink = <Button text={exceptionInfo.secondaryLinkText} href={exceptionInfo.secondaryLinkHref} />;
        }

        return (
            <ButtonGroup className="justify-center padding-top-16">
                {primaryLink}
                {secondaryLink}
            </ButtonGroup>
        );
    }
}

Components.add("ms.vss-work-web.hub-error-component", HubError);
